// extracted by mini-css-extract-plugin
export default {"containprod":"eB","containprod2":"fB","title":"gB","servings":"hB","recommendation":"iB","image":"jB","flavorswrap":"kB","flavorsgroupwrap":"lB","moredetailsWrap":"mB","infoWrap":"nB","price":"oB","regularPrice":"pB","netPrice":"qB","addtocartcontainer":"rB","error":"sB"};
    if(module.hot) {
      // 1713969933391
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  